/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_ACQUIS_SCHEMA = Yup.object().shape({
    //general section Rules:
    euAcquisId: Yup.string("euAcquisId Is alphanumeric").nullable(true),
    euAcquis: Yup.string("euAcquis ID is alphanumeric").nullable(true),
    regionalPartner: Yup.string("regionalPartner ID is alphanumeric").nullable(true),
    transpositionStatus: Yup.string("transpositionStatus is alphanumeric").nullable(true),     
    file: Yup.string("file ID is alphanumeric").nullable(true),
    DocumentPath:Yup.string("DocumentPath ID is alphanumeric").nullable(true),
    remarks: Yup.string("Road ID is alphanumeric").nullable(true)
});
const ACQUIS_INIT = {
    //general section Rules:
    euAcquisId: 0,
    euAcquis: "",
    regionalPartner: "",
    transpositionStatus: "", 
    file: "", 
    DocumentPath:"",  
    remarks: ""
}

export { TODIS_ACQUIS_SCHEMA, ACQUIS_INIT};